export default __webpack_public_path__ + "static/media/Kayoko.180f33fe.png";